import { useSelector } from 'react-redux';

import { User } from '../redux/slice/auth/auth.types';
import { RootState } from '../redux/store';

export const useAuthContext = () => {
  const user: User | null = useSelector((state: RootState) => state.auth?.user);
  return user;
};

export const useAuthInitializedContext = () => {
  const initialized: boolean = useSelector((state: RootState): boolean => state.auth.initialized);
  return initialized;
};
